import React from "react";

export const SpeechIcon = (props: any) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fillRule="evenodd" {...props}>
            <path  d="M14.67,8.91H21.3a.69.69,0,0,1,.7.68v3.89a.69.69,0,0,1-.7.69H18.64l-1,6.58,0,.3a1.11,1.11,0,0,1-1.1.95h-9a1.11,1.11,0,0,1-1.1-.95l0-.3-1-6.58H2.7a.69.69,0,0,1-.7-.69V9.59a.69.69,0,0,1,.7-.68H9.33V5.41a.69.69,0,0,1-.61-.68V2.68A.69.69,0,0,1,9.42,2H10.6a.7.7,0,0,1,.7.68V4.73a.68.68,0,0,1-.58.67V8.91h2.56V5.4a.68.68,0,0,1-.6-.67V2.68a.7.7,0,0,1,.7-.68h1.18a.69.69,0,0,1,.7.68V4.73a.68.68,0,0,1-.59.67ZM12,18.11a3,3,0,1,0-3.09-3A3.07,3.07,0,0,0,12,18.11Z"/>
        </svg>
    )
}